const ImageIconSVG = ({ className = "" }) => {
  return (
    // <svg
    //   className={className}
    //   width="25"
    //   height="24"
    //   viewBox="0 0 25 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M19.4297 3H5.42969C4.32512 3 3.42969 3.89543 3.42969 5V19C3.42969 20.1046 4.32512 21 5.42969 21H19.4297C20.5343 21 21.4297 20.1046 21.4297 19V5C21.4297 3.89543 20.5343 3 19.4297 3Z"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M8.92969 10C9.75811 10 10.4297 9.32843 10.4297 8.5C10.4297 7.67157 9.75811 7 8.92969 7C8.10126 7 7.42969 7.67157 7.42969 8.5C7.42969 9.32843 8.10126 10 8.92969 10Z"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M21.4297 15L16.4297 10L5.42969 21"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
    <svg width="35" height="35" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="3" y="4" width="18" height="16" rx="2" fill="#8BD3FF"/>
      <circle cx="9" cy="9" r="2" fill="#FFD54F"/>
      <path d="M4 18L10 12L14 16L17 13L20 18H4Z" fill="#4CAF50"/>
    </svg>
  );
};

export default ImageIconSVG;
